import { IOrderBasis } from '@/coreDomainsModule/entities/orderBasis';
import { IAnnounceDaily } from '@/coreDomainsModule/entities/forecast';

/**
 * 発注根拠に関する共通サービス
 */
export class OrderBasisService {
  /**
   * 発注根拠チャートで使う日別内示を返す
   * 新スキーマのsnapshotを優先し、旧スキーマ互換データがある場合のみfallbackする
   * @param basis - 発注根拠
   */
  public static getCustomerAnnounceDailyForChart(basis: IOrderBasis): IAnnounceDaily[] {
    const snapshotCustomerAnnounceDaily = OrderBasisService.buildSnapshotCustomerAnnounceDaily(basis);
    if (snapshotCustomerAnnounceDaily.length > 0) return snapshotCustomerAnnounceDaily;

    return basis.customerAnnounceDaily;
  }

  /**
   * 発注根拠の日次スナップショット内客先内示情報をIAnnounceDaily[]に変換する
   * @param basis - 発注根拠
   * @returns - IAnnounceDaily[]
   */
  private static buildSnapshotCustomerAnnounceDaily(basis: IOrderBasis): IAnnounceDaily[] {
    return basis.nextMonthlyInfos.flatMap((monthly) =>
      monthly.dailyInfos.flatMap((daily): IAnnounceDaily[] =>
        daily.snapshotCustomerForecastDailyAmount != null
          ? [
              {
                year: monthly.orderBasisTargetYearMonth.year,
                month: monthly.orderBasisTargetYearMonth.month,
                day: daily.orderBasisTargetDay,
                amount: daily.snapshotCustomerForecastDailyAmount,
                manageInitiatedYearMonth: undefined,
                createAt: undefined,
                updateAt: undefined,
              },
            ]
          : []
      )
    );
  }
}
